import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'

import reportWebVitals from './reportWebVitals';
import store from "./redux/store";
import App from './App';
import './index.css';
import "animate.css";
import {initialiseFirebase} from "./helpers/firebase";
import isToday from "dayjs/plugin/isToday";
import dayjs from "dayjs";

dayjs.extend(isToday);

initialiseFirebase();

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();